<template>
    <el-card class="yl-title clearfix w100">
        <div class="fl">
            <span class="pointer ft16 back_text" v-if="!disabledBack" @click="back">
                <i class="el-icon-back fw7"></i>
                <span>返回</span>
            </span>
            <span>{{title}}</span>
            <span class="sub_title" v-if="subTitle">{{subTitle}}</span>
        </div>
        <div class="fr">
            <slot></slot>
        </div>
        <!-- 
            title: 标题文字
            subTitle: 副标题文字
            redirect: 动态传入路由地址，不传则为go(-1)
            disabledBack: 是启用返回按钮 默认为启用
            custReturn: 点击返回执行的事件（此方法不执行跳转）
        -->
    </el-card>
</template>
<script>
export default {
    name: 'yl-lc-title',
    props:{
        title:{
            type:String,
            default:""
        },
        subTitle:{
            type:String,
            default:""
        },
        redirect:{
            type:String,
            default:""
        },
        disabledBack:{
            type:Boolean,
            default:false
        },
        custReturn:{
            type:Function,
            default:null
        },
        backText: {
            type:String,
            default:""
        }
    },
    data() {
        return {
            iconColor: "#303133"
        }
    },
    mounted() {},
    methods: {
        back(){
            if(typeof this.custReturn=="function"){
                this.custReturn();
                return false;
            }
            if(this.redirect){
                this.$router.push({
                    path:this.redirect
                });
                return false;
            }
            this.$router.go(-1);
        }
    }
}
</script>
<style>
    .yl-title .sub_title {
        font-size: 14px;
        color: #909399;
        margin-left: 8px;
        font-weight: 400;
    }
</style>